import React from 'react';

import { FormInstance } from 'antd';
import {
  Select,
  Radio,
} from 'UI';
import {
  PaymentCategoryEnum,
  PaymentCategoryMapping,
  PaymentMethodEnum,
  PaymentMethodMapping,
} from 'constants/payment';

import {
  FormContainer,
  BaseFormItem,
} from './style';

export interface PaymentUpdateClientFormData {
  paymentCategory?: PaymentCategoryEnum | null
  paymentIsUpfront?: string
  paymentMethod?: PaymentMethodEnum | null
}

interface PaymentUpdateClientFormProps {
  formHandler: FormInstance
  data: PaymentUpdateClientFormData
  onDataChange(changedValue: unknown, formData: unknown): void
  isLoading?: boolean
}

const PaymentUpdateClientForm = ({
  formHandler,
  data,
  onDataChange,
  isLoading,
}: PaymentUpdateClientFormProps): JSX.Element => (
  <FormContainer
    layout="vertical"
    form={formHandler}
    requiredMark={false}
    initialValues={data}
    onValuesChange={onDataChange}
  >
    <BaseFormItem
      label="Categoria"
      name="paymentCategory"
    >
      <Select disabled={isLoading} placeholder="Selecione" allowClear>
        {Object.values(PaymentCategoryEnum).map((cat) => (
          <Select.Option value={cat} key={cat}>{PaymentCategoryMapping[cat]}</Select.Option>
        ))}
      </Select>
    </BaseFormItem>
    <BaseFormItem
      label="Precisa pagar adiantamento?"
      name="paymentIsUpfront"
      initialValue="true"
    >
      <Radio.Group>
        <Radio value="true">Sim</Radio>
        <Radio value="false">Não</Radio>
      </Radio.Group>
    </BaseFormItem>
    <BaseFormItem
      label="Forma de pagamento"
      name="paymentMethod"
    >
      <Select disabled={isLoading} placeholder="Selecione" allowClear>
        {Object.values(PaymentMethodEnum).map((method) => (
          <Select.Option value={method} key={method}>{PaymentMethodMapping[method]}</Select.Option>
        ))}
      </Select>
    </BaseFormItem>
  </FormContainer>
);

PaymentUpdateClientForm.defaultProps = {
  isLoading: false,
};

export default PaymentUpdateClientForm;
